export default __webpack_public_path__ + "static/media/secure1.489a173c.png";